import "./statusList.scss";

const StatusList = ({ status }) => {
  return (
    <div className="status-list">
      <div className={`status-list__item ${status === "Draft" && "status-list__item--active"}`}>
        <span className="status-list__item-name">Draft</span>
        <i className="status-list__item-indicator status-list__item-indicator--draft"></i>
      </div>
      <div className={`status-list__item ${status === "Review" && "status-list__item--active"}`}>
        <span className="status-list__item-name">Review</span>
        <i className="status-list__item-indicator status-list__item-indicator--review"></i>
      </div>
      <div className={`status-list__item ${status === "Approved" && "status-list__item--active"}`}>
        <span className="status-list__item-name">Approved</span>
        <i className="status-list__item-indicator status-list__item-indicator--approved"></i>
      </div>
      { status === "Publishing" ? (
        <div className={`status-list__item status-list__item--active`}>
          <span className="status-list__item-name">Publishing</span>
          <i className="status-list__item-indicator status-list__item-indicator--published"></i>
        </div>
      ) : (
        <div className={`status-list__item ${status === "Published" && "status-list__item--active"}`}>
          <span className="status-list__item-name">Published</span>
          <i className="status-list__item-indicator status-list__item-indicator--published"></i>
        </div>
      )}
      { status === "Obsolete" && (
        <div className={`status-list__item status-list__item--active`}>
          <span className="status-list__item-name">Obsolete</span>
          <i className="status-list__item-indicator status-list__item-indicator--obsolete"></i>
        </div>
      )}
    </div>
  );
};

export default StatusList;
